import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isTokenExpired, logout } from "../utils/auth";

const useAutoLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isTokenExpired()) {
      logout();
      navigate("/login");
      return;
    }

    // Periodic check every 1 minute
    const interval = setInterval(() => {
      if (isTokenExpired()) {
        logout();
        navigate("/login");
      }
    }, 60000); // Check every 60 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [navigate]);
};

export default useAutoLogout;
